export class OralDeposition {
  id: number;
  intranet_id: number;
  matter_id: number;
  matter_history_id: number;
  deponent_id: number;
  stenographer_id: number;
  status: string;
  notes: string;
  fee: number = 0;
  schedule_by: any;
  created_at: any;
  updated_at: any;
  created_by: any;
  updated_by: any;
  address_id: number | null;
  judge_id: number;
  created_at_str: string;
  deponent_name: string;
  address_simple: string;
  schedule_by_str: string;
  judge_name: string;
  stenographer_name: string;
  status_str: string;
  participants: Array<any>;
  matter_history_notes: Array<any>;
  oral_deposition_events: Array<any>;
  editing_allowed: boolean = false;
  deponent_phone_number: string;
  deponent_notes: string;
  templates: any;
  matter_name: string;
  created_by_contact_name: string;
  scheduled_event: any;
  deponent_address: string;
  scheduled: any;
  created_by_contact_id: number;
  matter_number: number;
}
